import app from '../app';
import classList from '../utils/classList';
import Dropdown from './Dropdown';
import Button from './Button';
import Tooltip from './Tooltip';
import Select from './Select';
export default class MultiSelect extends Select {
  selected = [];
  oninit(vnode) {
    super.oninit(vnode);
    this.selected = this.attrs.value || [];
  }
  input() {
    const {
      options,
      onchange,
      disabled,
      className,
      class: _class,
      ...domAttrs
    } = this.attrs;
    return m(Dropdown, {
      disabled: disabled,
      buttonClassName: "Button",
      buttonAttrs: {
        disabled
      },
      label: Object.keys(options).filter(key => this.selected.includes(key)).map(key => typeof options[key] === 'string' ? options[key] : options[key].label).join(', ') || app.translator.trans('core.lib.multi_select.placeholder')
    }, Object.keys(options).map(key => {
      const option = options[key];
      const label = typeof option === 'string' ? option : option.label;
      const tooltip = typeof option !== 'string' && option.tooltip;
      let disabled = typeof option !== 'string' && option.disabled;
      if (typeof disabled === 'function') {
        disabled = disabled(this.selected);
      }
      const button = m(Button, {
        type: "button",
        className: classList('Dropdown-item', `Dropdown-item--${key}`, {
          disabled
        }),
        onclick: this.toggle.bind(this, key),
        disabled: disabled,
        icon: this.selected.includes(key) ? 'fas fa-check' : 'fas fa-empty'
      }, label);
      if (tooltip) {
        return m(Tooltip, {
          text: tooltip
        }, button);
      }
      return button;
    }));
  }
  select(value) {
    this.selected.push(value);
  }
  unselect(value) {
    this.selected = this.selected.filter(v => v !== value);
  }
  toggle(value, e) {
    e.stopPropagation();
    if (this.selected.includes(value)) {
      this.unselect(value);
    } else {
      this.select(value);
    }
    if (this.attrs.onchange) {
      this.attrs.onchange(this.selected);
    }
  }
}
flarum.reg.add('core', 'common/components/MultiSelect', MultiSelect);